import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnAT: CultureInfo = {
  name: 'en-AT',
  displayName: 'English (Austria)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-AT',
  parent: CultureInfoEn
};
